import LocationProvider from './LocationProvider'

export default LocationProvider

export { useLocation } from './LocationContext'
